import CategoryAppConfig from './category/DataAppConfig';
import CurrencyAppConfig from './currency/CurrencyAppConfig';
import GeneralSettingsAppConfig from './general/DataAppConfig';
import AdminReportGettersConfig from './AdminReportGetters/AdminReportGettersAppConfig';
import IncomeTypeAppConfig from './incomeType/IncomeTypeAppConfig';
import CategoryGroup from './categoryGroup/DataAppConfig';
import DailyReportAppConfig from './dailyReport/DataAppConfig';
import NegativeStockAppConfig from './negativeStock/DataAppConfig';

const SettingsAppConfig = [
	GeneralSettingsAppConfig,
	CurrencyAppConfig,
	CategoryAppConfig,
	IncomeTypeAppConfig,
	AdminReportGettersConfig,
	CategoryGroup,
	DailyReportAppConfig,
	NegativeStockAppConfig
];

export default SettingsAppConfig;
